import { useMyAccountStore } from '../../../stores/useMyAccountStore';

interface SecurityInfoSectionProps {
  isImpersonating: boolean;
  customerServicePhone: string;
}

export function SecurityInfoSection({ isImpersonating, customerServicePhone }: SecurityInfoSectionProps) {
  const {
    securityEmail,
    securitySubmitting,
    securityError,
    securitySuccess,
    setSecurityEmail,
    saveSecurityInfo,
    clearSecurityState,
  } = useMyAccountStore();

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    clearSecurityState();
    saveSecurityInfo();
  }

  return (
    <div className="account-wrapper">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <h1>
            Edit Account <small>Security Information</small>
          </h1>
          <hr />
        </div>
      </div>

      {securitySuccess && (
        <div className="alert alert-success" role="alert">
          <strong>Success!</strong> You have successfully updated your email address.
        </div>
      )}

      {securityError && (
        <div className="alert alert-danger" role="alert">
          {securityError} Please contact Member Services at {customerServicePhone}.
        </div>
      )}

      <form name="editSecurityInfo" className="edit-security-info" onSubmit={handleSubmit} autoComplete="off">
        <div className="row">
          <div className="col-lg-9 col-md-9 col-sm-9">
            <div className="form-group">
              <label htmlFor="securityEmail">E-mail Address</label>
              <input
                id="securityEmail"
                name="emailAddress"
                type="email"
                className="form-control"
                value={securityEmail}
                onChange={e => setSecurityEmail(e.target.value)}
                disabled={isImpersonating}
                maxLength={255}
                required
              />
              <span>
                <br />Updating this E-mail will change your login credentials.
              </span>
              <span style={{ color: '#FF0000' }}>
                <b>
                  <br /><br />
                  Please allow up to 20 minutes for your email address change to fully process
                  before attempting to log in again.
                  <br />
                  Logging in too soon may result in an invalid verification code being sent to
                  you, which could prevent a successful login.
                </b>
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-9 col-md-9 col-sm-9">
            <h4>Update Password</h4>
            <p>
              To update your password, use the <strong>Forgot Password</strong> link on the login
              screen for Member Portal
            </p>
            <br />
            <h4>Change Login Authentication Method</h4>
            <p>
              To change your login authentication method (text or email), call Member Services at{' '}
              <strong>{customerServicePhone}</strong>
            </p>
            <br />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-8">
            <button
              type="submit"
              className="change-security-information btn btn-success btn-lg pull-right"
              disabled={isImpersonating || securitySubmitting}
            >
              {securitySubmitting ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
